import React from 'react'
import './Renderers.css'
export class Renderers {
    constructor(
        enterEdit,
        exitEdit,
        editFieldName,
        handleContextMenuOpen,
        onMouseDown,
        onMouseOver,
        onMouseUp,
        selectedFieldName
    ) {
        this.enterEdit = enterEdit
        this.exitEdit = exitEdit
        this.onMouseDown = onMouseDown
        this.onMouseUp = onMouseUp
        this.onMouseOver = onMouseOver
        this.editFieldName = editFieldName
        this.selectedFieldName = selectedFieldName
        this.handleContextMenuOpen = handleContextMenuOpen
    }

    cellRender = (tdElement, cellProps) => {
        const dataItem = cellProps.dataItem
        let disabled = !!!dataItem['Part Number']
        const cellField = cellProps.field
        const loading = dataItem.loading
        const inEditField = dataItem[this.editFieldName]
        const selected = dataItem[this.selectedFieldName] && dataItem.selectedColumns[cellField]
        let selectedFields = dataItem.selectedColumns ? Object.keys(dataItem.selectedColumns) : []
        const onlySelected =
            selectedFields.length === 1 &&
            selectedFields[0] === cellField &&
            dataItem.onlySelectedTentative
        const additionalProps =
            cellField && cellField === inEditField
                ? {
                    ref: (td) => {
                        const input = td && td.querySelector('input')

                        const activeElement = document.activeElement
                        if (td) {
                            if (
                                !window.scrolledTo ||
                                  window.scrolledTo !== inEditField + dataItem['Part Number']
                            ) {
                                td.scrollIntoView()
                                window.scrolledTo = inEditField + dataItem['Part Number']
                            }
                        }
                        if (
                            !input ||
                              !activeElement ||
                              input === activeElement ||
                              !activeElement.contains(input)
                        ) {
                            return
                        }

                        if (input.type === 'checkbox') {
                            input.focus()
                        } else {
                            input.select()
                        }
                    },
                }
                : {
                    // onClick: () => { this.enterEdit(dataItem, cellField); },
                    onMouseDown: (e) => {
                        !disabled && this.onMouseDown(e, dataItem, cellField)
                    },
                    onMouseOver: (e) => {
                        this.onMouseOver(e, dataItem, cellField)
                    },
                    onMouseUp: (e) => {
                        this.onMouseUp(e, dataItem, cellField)
                    },
                    onContextMenu: (e) => {
                        this.handleContextMenuOpen(e, dataItem, cellField)
                    },
                    onKeyPress: (e) => {
                        onlySelected && this.enterEdit(e, dataItem, cellField)
                    },
                    className: 'awcgridcell',
                    // width: 7px;
                    // height: 7px;
                    // margin: -3px -4px -4px -3px;
                    // z-index: 10000;
                    // position: relative;
                    // top: 21px;
                    // cursor: pointer;
                    // float: right;
                    // background-color: blue;
                    // left: 10px;
                    style: {
                        height: 30,
                        // overflowY: "visible",
                        // overflowX: "visible",
                        // position: "absolute",
                        wordBreak: 'break-all',
                        whiteSpace: 'nowrap',
                        boxShadow: selected ? 'inset 0 -100px 0 rgba(33,133,208,.15)' : '',
                        ...tdElement.props.style,
                    },
                }
        //    top: 37px;
        //left: 10px;
        // bottom: -5px;
        // right: -10px;

        const square = (
            <div
                style={{
                    width: 10,
                    height: inEditField ? 7 : 10,
                    marginRight: -5,
                    marginBottom: -1,
                    zIndex: 10000,
                    bottom: -3,
                    right: -7,
                    position: 'absolute',
                    cursor: 'pointer',
                    float: 'right',
                    backgroundColor: 'blue',
                }}
                onMouseDown={(e) => {
                    e.stopPropagation()
                    dataItem.onFloodFillStart(dataItem, cellField)
                }}
                onMouseUp={(e) => {
                    e.stopPropagation()
                    dataItem.onFloodFillEnd()
                }}
            />
        )
        const handleChange = (e) => {
            cellProps.onChange({
                dataItem: dataItem,
                field: cellField,
                syntheticEvent: e,
                value: e.target.value,
            })
        }
        let inner = (
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        wordBreak: 'break-all',
                        whiteSpace: 'nowrap',
                        position: 'relative',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'inline-block',
                        width: '100%',
                    }}
                >
                    {dataItem.selectedColumns &&
                    selected &&
                    dataItem.selectedColumns[cellField] &&
                    dataItem.floodFilling
                        ? dataItem.floodFilling
                        : // if it's a string use our string because theirs treats '.' as a nested value so we can't use periods with their values
                        typeof tdElement.props.children === 'string'
                            ? dataItem[cellField]
                            : tdElement.props.children &&
                          React.createElement('input', {
                              style: { width: '100%' },
                              className: 'k-textbox',
                              value: dataItem[cellField] || '',
                              onChange: handleChange,
                          })}
                </div>
                {onlySelected && square}
            </div>
        )
        let newChildren = [inner]

        let loadingDiv = (
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'black',
                    display: 'flex',
                    alignItems: 'center',
                }}
            ></div>
        )
        // if(tdElement.props.children)
        //     newChildren.push(square)
        // else
        //     newChildren = [square]
        return React.cloneElement(
            tdElement,
            { ...tdElement.props, ...additionalProps },
            newChildren
        )
    }

    rowRender = (trElement, rowProps) => {
        const trProps = {
            ...trElement.props,
            onMouseDown: () => {
                this.preventExit = true
                clearTimeout(this.preventExitTimeout)
                this.preventExitTimeout = setTimeout(() => {
                    this.preventExit = undefined
                })
            },
            onBlur: () => {
                clearTimeout(this.blurTimeout)
                if (!this.preventExit) {
                    this.blurTimeout = setTimeout(() => {
                        this.exitEdit()
                    })
                }
            },
            onFocus: () => {
                clearTimeout(this.blurTimeout)
            },
            className: rowProps.dataItem.loading ? 'loading' : trElement.props.className,
            style: {
                height: 30,
                width: '100%',
                position: 'relative',
                wordBreak: 'break-all',
                ...trElement.props.style,
            },
            key: rowProps.dataItem.index,
        }
        let loadingDiv = (
            <td>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div
                        className="k-icon k-i-loading"
                        style={{ fontSize: 28, color: 'white' }}
                    ></div>
                </div>
            </td>
        )
        return React.cloneElement(
            trElement,
            { ...trProps },
            rowProps.dataItem.loading ? loadingDiv : trElement.props.children
        ) //trElement.props.children
    }
}
